import React from 'react';
import { motion } from 'framer-motion';
import { User } from 'lucide-react';

export default function RosterPage() {
  const advisoryBoard = [
    {
      id: 1,
      name: 'Phoenix',
      role: 'CEO',
      initial: 'P'
    },
    {
      id: 2,
      name: 'Twig Capone',
      role: 'COO',
      initial: 'TC'
    },
    {
      id: 3,
      name: 'Trey Billingsley',
      role: 'Marketing and Promotion, DJ',
      initial: 'TB'
    },
    {
      id: 4,
      name: 'Claudia Darobi',
      role: 'DiverseCiti™ Business Advocate',
      initial: 'CD'
    },
    {
      id: 5,
      name: 'Damon Shepherd',
      role: 'Financial Consultant',
      initial: 'DS'
    },
    {
      id: 6,
      name: 'Mark Thomason, Jr.',
      role: 'Executive Producer',
      initial: 'MT'
    }
  ];

  return (
    <div className="min-h-screen py-24 bg-[#1A1412]" data-testid="roster-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-[#CFB53B] uppercase tracking-[0.2em] text-xs font-['Outfit'] font-light">Leadership</span>
          <h1 className="font-['Playfair_Display'] text-4xl sm:text-5xl lg:text-6xl font-bold text-[#FDFBF7] mb-4 tracking-tight mt-4">
            Vintage Ave Records
          </h1>
          <h2 className="font-['Playfair_Display'] text-2xl sm:text-3xl font-bold text-[#D97736] mb-2">
            Advisory Board
          </h2>
          <h3 className="font-['Outfit'] text-lg sm:text-xl text-[#CFB53B] italic mb-4">
            The Team Behind the Machine
          </h3>
          <p className="text-[#A89B95] text-lg font-['Outfit'] max-w-2xl mx-auto">
            Meet the visionaries behind the future of vintage soul.
          </p>
        </motion.div>

        {/* Advisory Board Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {advisoryBoard.map((member, index) => (
            <motion.div
              key={member.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group"
              data-testid={`team-card-${index}`}
            >
              <div className="bg-gradient-to-br from-[#2C221F] to-[#1A1412] rounded-2xl p-8 border border-[#3D302C] hover:border-[#D97736] transition-all duration-300 h-full">
                {/* Avatar */}
                <div className="flex justify-center mb-6">
                  <div className="w-24 h-24 rounded-full bg-gradient-to-br from-[#D97736] to-[#CFB53B] flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <span className="text-[#1A1412] text-3xl font-['Playfair_Display'] font-bold">
                      {member.initial}
                    </span>
                  </div>
                </div>

                {/* Name */}
                <h3 className="text-[#FDFBF7] font-['Playfair_Display'] text-2xl font-bold text-center mb-2">
                  {member.name}
                </h3>

                {/* Role */}
                <div className="text-center">
                  <span className="inline-block bg-[#D97736]/20 text-[#D97736] px-4 py-2 rounded-full text-sm font-['Outfit'] font-medium">
                    {member.role}
                  </span>
                </div>

                {/* Decorative Line */}
                <div className="mt-6 flex justify-center">
                  <div className="w-16 h-1 bg-gradient-to-r from-transparent via-[#CFB53B] to-transparent rounded-full"></div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom Decoration */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-20 text-center"
        >
          <div className="inline-flex items-center gap-4">
            <div className="w-20 h-px bg-gradient-to-r from-transparent to-[#D97736]"></div>
            <div className="w-3 h-3 rounded-full bg-[#CFB53B]"></div>
            <span className="text-[#A89B95] text-sm font-['Outfit'] uppercase tracking-widest">The Future of Vintage Soul</span>
            <div className="w-3 h-3 rounded-full bg-[#CFB53B]"></div>
            <div className="w-20 h-px bg-gradient-to-l from-transparent to-[#D97736]"></div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
